import initialState from "./initialState";
import { imageCdnUrls } from "../../components/common/ImageCdnUrls";
import MAP_OVERLAYS from "../../constants/mapOverlays";
import {
    GET_MAP_OVERLAYS_SUCCESS,
    GET_MAP_OVERLAYS_FAIL,
    TOGGLE_MAP_OVERLAY
} from "../../actions/maps/mapOverlayAction";

export default function mapOverlayReducer(state = initialState, action) {

    switch (action.type) {

        case GET_MAP_OVERLAYS_SUCCESS: {
            return {
                ...state,
                mapOverlayOptions: action.mapOverlayOptions.map(layer => {
                    return {
                        id: layer.id,
                        name: layer.displayName,
                        icon: getMapOverlayIcon(layer.id),
                        hoverIcon: getMapOverlayHoverIcon(layer.id),
                        isSelected: false
                    };
                })
            };
        }

        case GET_MAP_OVERLAYS_FAIL: {
            return {...state};
        }

        case TOGGLE_MAP_OVERLAY: {
            return {
                ...state,
                mapOverlayOptions: state.mapOverlayOptions
                    .map(layer => {
                        return {
                            ...layer,
                            isSelected: layer.id === action.activeMapOverlayId
                        };
                    }),
                activeMapOverlayId: action.activeMapOverlayId

            };
        }

        default: {
            return state;
        }
    }
}

function getMapOverlayIcon(mapOverlayId) {
    switch (mapOverlayId) {
        case MAP_OVERLAYS.NONE:
            return null;
        case MAP_OVERLAYS.COVID:
            return imageCdnUrls.virus;
        case MAP_OVERLAYS.FIRE_PERIMETER:
            return imageCdnUrls.wildfire;
        case MAP_OVERLAYS.TROPICAL_WEATHER:
            return imageCdnUrls.hurricane;
        default:
            return null;
    }
}

function getMapOverlayHoverIcon(mapOverlayId) {
    switch (mapOverlayId) {
        case MAP_OVERLAYS.NONE:
            return null;
        case MAP_OVERLAYS.COVID:
            return imageCdnUrls.virus_white;
        case MAP_OVERLAYS.FIRE_PERIMETER:
            return imageCdnUrls.wildfire_white;
            case MAP_OVERLAYS.TROPICAL_WEATHER:
                return imageCdnUrls.hurricane_white;
        default:
            return null;
    }
}
